import commaUp from '../../../assets/images/solution/digital/comma-up.png'
import commaDown from '../../../assets/images/solution/digital/comma-down.png'

import logo1 from '../../../assets/images/solution/digital/logo1.png'
import logo2 from '../../../assets/images/solution/digital/logo2.png'
import logo3 from '../../../assets/images/solution/digital/logo3.png'
import logo4 from '../../../assets/images/solution/digital/logo4.png'


import styles from './style.module.scss'

function DigitalTransformation() {
    return (
        <div className={`solution-introduction-wrapper ${styles['digital-wrapper']}`}>
            <div className={`banner ${styles['banner']}`}>
                <div className='title'>企业数字化转型</div>
                <div className='content'>运用云计算、大数据技术构建集采购、生产、营销、人力、财务等一体的数字化管理解决方案</div>
            </div>
            <div className={`introduction-wrapper ${styles['introduction-wrapper']}`}>
                <p className='title'>方案简介</p>
                <div className={`introduction-title ${styles['introduction-title']}`}>
                    <div>
                        <img src={commaUp} alt="" />
                        <p>企业数字化转型</p>
                        <p>烽火星空运用云计算、大数据技术构建集采购、生产、营销、人力、财务等一体的数字化管理解决方案，助力企业管理者掌控日常运营全景，推动组织创新、协同办公，提升核心竞争力。</p>
                        <img src={commaDown} alt="" />
                    </div>
                </div>
            </div>
            <div className={styles['introduction-content']}>
                <div className={styles['introduction-item']}>
                    <img src={logo1} alt="" />
                    <p>物联网感知设备</p>
                    <p>助力全流程数据化管理</p>
                </div>
                <div className={styles['introduction-item']}>
                    <img src={logo2} alt="" />
                    <p>智能驾驶舱</p>
                    <p>助力精准决策远景规划</p>
                </div>
                <div className={styles['introduction-item']}>
                    <img src={logo3} alt="" />
                    <p>强大数据治理体系</p>
                    <p>打造灵活数据资产管理平台</p>
                </div>
                <div className={styles['introduction-item']}>
                    <img src={logo4} alt="" />
                    <p>专业的分析团队</p>
                    <p>助力释放数据内涵价值</p>
                </div>
            </div>
            <div className={`achievement-wrapper ${styles['achievement-wrapper']}`}>
                <p className='title'>典型实践</p>
                <div className={styles['achievement-container']}>
                    <div className={styles['achievement-item']}>
                        <div className={styles['img']}></div>
                        <p className={styles['title']}>方案实现</p>
                        <p className={styles['sub-title']}>烽火星空帮助锐拓光棒制造厂实现了生产监控数字化，为12条光棒产线建设了2000个生产数据采集点</p>
                    </div>
                    <div className={styles['achievement-item']}>
                        <div className={styles['img']}></div>
                        <p className={styles['title']}>效率提升</p>
                        <p className={styles['sub-title']}>通过构建四大类五十个数据分析模型去发现问题、优化生产工艺、提升生产效率和生产质量</p>
                    </div>
                    <div className={styles['achievement-item']}>
                        <div className={styles['img']}></div>
                        <p className={styles['title']}>成品良品率提升</p>
                        <p className={styles['sub-title']}>自项目上线一年后，成品良品率从前期的50%提升如今的90%+</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DigitalTransformation